import React from 'react';

const Task = ({ task, moveTask }) => { // test
    return (
        <div className="kanban-task">
            <h4>{task.title}</h4>
            <p>{task.description}</p>
            <div className="task-actions">
                <button
                    onClick={() => moveTask(task._id, -1)}
                    disabled={task.status === 'To Do'}
                >
                    ←
                </button>
                <button
                    onClick={() => moveTask(task._id, 1)}
                    disabled={task.status === 'Done'}
                >
                    →
                </button>
            </div>
        </div>
    );
};

export default Task;
